import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { cloneDeep } from 'lodash';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { FIELD_TYPE, OTHER_TYPE, RECORD_TYPE } from '../../../constants/datatypes';
import { treeActions } from '../../../redux/slices/treeSlice';
import { getRecordInsertingPosition, getSelectedNodes } from './CopyAndPaste';
import { getUpdatedData } from './NewRecord';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import ErrorModal from '../../ItemProperties/Forms/FieldDataValidation/ErrorModal';
import { genKey, nestedNodeIdAssign } from '../../../utils/utilFunctions';

const initialMiddleProcessObject = {
    status: false,
    index: null,
    isInside: false,
    pasteModal: false,
};

function CopyAndPasteXML({ isCopied, setIsCopied ,contextMenuType,treeType }) {
    const { t } = useTranslation();
    const [copiedNodes, setCopiedNodes] = useState([]);
    const [inMiddleProcess, setInMiddleProcess] = useState(
        initialMiddleProcessObject
    );
    const [content, setContent] = useState("");
    const [showError,setShowError] = useState(false);
    const [error,setError] = useState('');  
    const [pasteModalTriggered, setPasteModalTriggered] = useState(false);
    const parentScreen = useContext(ParentScreenCtx);
    const { rightTree, leftTree } = useSelector((state) => state.treeData[parentScreen]);
    const currentTab = rightTree.currentTab;
    const selectedNode = rightTree.tree[currentTab].selectedNode;
    const templateHeader = rightTree.tree.templateHeader;
    const { selectedKeysArray, translatedData } = rightTree.tree[currentTab];

    const contentRef = useRef();
    const dispatch = useDispatch();

    const getTitleOfCopiedNode = (parentArray, node) => {
        ////--------------------Function to Get New Element New On Every Element Creation------------------------////
        const { ICON_DISPLAY } = node;
        let title;
        if (ICON_DISPLAY === 'ELEMENT' || ICON_DISPLAY === 'REPEATING_ELEMENT') title = node?.ELEMENT_NAME || node?.TYPE || node?.title;
        else title = node?.title
        const data = cloneDeep(parentArray);
        const copiedNodeTitle = FIELD_TYPE[ICON_DISPLAY]
            ? title.replace(`${FIELD_TYPE[ICON_DISPLAY].type}: `, "")
            : title;
        let titleNumber;

        const getTitleName = (data) => {
            data.forEach((ele) => {
                let tempTitle;
                if (ICON_DISPLAY === 'ELEMENT' || ICON_DISPLAY === 'REPEATING_ELEMENT') tempTitle = ele?.ELEMENT_NAME || ele?.TYPE || ele?.title;
                else tempTitle = ele?.title;
                let title = FIELD_TYPE[ele.ICON_DISPLAY]
                    ? tempTitle.replace(`${FIELD_TYPE[ele.ICON_DISPLAY]?.type}: `, "")
                    : tempTitle;
                const firstOccurance = title.indexOf(t("FRG_COPY_OF_"));
                const startingBracket = title.indexOf("(");
                const endingBracket = title.indexOf(")");
                let previousNumberOfCopy;

                if (
                    startingBracket >= 0 &&
                    endingBracket >= 0 &&
                    endingBracket > startingBracket &&
                    endingBracket - startingBracket + t("FRG_COPY_OF_").length >= 1 &&
                    startingBracket - (firstOccurance + t("FRG_COPY_OF_").length - 1) === 1
                ) {
                    previousNumberOfCopy = title.substring(
                        startingBracket + 1,
                        endingBracket
                    );
                    title =
                        title.substring(0, startingBracket) + title.slice(endingBracket + 1);
                } else {
                    previousNumberOfCopy = false;
                }

                if (title === `${t("FRG_COPY_OF_")} ${copiedNodeTitle}`) {
                    if (titleNumber === undefined) titleNumber = 0;
                    if (
                        startingBracket >= 0 &&
                        endingBracket >= 0 &&
                        !isNaN(previousNumberOfCopy)
                    ) {
                        titleNumber =
                            Number(previousNumberOfCopy) > titleNumber
                                ? Number(previousNumberOfCopy)
                                : titleNumber;
                    }
                }
            });
        };
        getTitleName(data);

        return titleNumber === undefined
            ? `${t("FRG_COPY_OF_")} ${copiedNodeTitle}`
            : `${t("FRG_COPY_OF_")}(${titleNumber + 1}) ${copiedNodeTitle}`;
    };

    const copyItems = async (isNested, node, selectedNode) => {
        let levels = selectedNode?.key?.split('-');
        levels = levels?.splice(1);

        const insertElement = (translatedData, levels, isNested) => {
            const level = isNested ? 0 : 1;
            if (levels.length === level) {
                const { children } = translatedData;
                const title = getTitleOfCopiedNode(children ? children : translatedData, node);

                let newElement;
                const newTranslatedData = children ? translatedData?.children : translatedData;
                let newNodePlace;
                let fieldNumber = 0;

                newTranslatedData?.forEach((element, index) => {
                    if (element.key === selectedNode.key) newNodePlace = index + 1;
                    if (element.ICON_DISPLAY === node.ICON_DISPLAY) fieldNumber++;
                });

                if (node.ICON_DISPLAY === 'ATTRIBUTE') {
                    newElement = {
                        ...node,
                        title: title,
                        GUI_XML_SORT_ORDER: `${fieldNumber + 1}`,
                        MAPNAME: title,
                        DESCRIPTION: title,
                        ATTRIBUTE_NAME: title
                    }
                } else if (node.ICON_DISPLAY === 'ELEMENT' || node.ICON_DISPLAY === 'REPEATING_ELEMENT') {
                    newElement = {
                        ...node,
                        title: `<${title}>`,
                        ELEMENT_NAME: `${title}`
                    }
                } else {
                    newElement = { ...node };
                }

                // Inserting Position accodoing to type
                let slicePoint;
                let elementKey;

                if (RECORD_TYPE[newElement.ICON_DISPLAY]) {
                    const { index, key } = getRecordInsertingPosition(newTranslatedData, selectedNode, isNested, parentScreen, currentTab);
                    slicePoint = index;
                    elementKey = key;
                } else {
                    slicePoint = isNested ? 0 : newNodePlace;
                    const selectedKey = selectedNode.key?.split('-');
                    if (isNested) selectedKey?.push(slicePoint);
                    else selectedKey[selectedKey?.length - 1] = slicePoint;
                    elementKey = selectedKey?.join('-');
                }
                newElement['key'] = elementKey;
                newElement = nestedNodeIdAssign(newElement);
                newTranslatedData.splice(slicePoint, 0, newElement);

                dispatch(
                    treeActions.setRightTreeSelectedNode({
                        screen: parentScreen,
                        type: currentTab,
                        data: newElement,
                    })
                );
                return;
            }

            const isArray = Array.isArray(translatedData);

            if (isArray) {
                const nestedData = translatedData[[levels[0]]];
                const newLevels = levels.splice(1);
                insertElement(nestedData, newLevels, isNested);
            } else insertElement(translatedData?.children, levels, isNested);
        }
        setTimeout(() => {
            const newTranslatedData = cloneDeep(
                rightTree.tree[currentTab].translatedData
            );
            insertElement(newTranslatedData, levels, isNested);
            const updatedData = getUpdatedData(newTranslatedData, templateHeader?.FILETYPE);
            dispatch(
                treeActions.setNewRightTreeTranslatedData({
                    screen: parentScreen,
                    type: currentTab,
                    data: updatedData,
                })
            );
        }, 0);
    }

    const updatePasteModalContent = () =>{
        const contentText = 'BOX_LIKE_TO_PLACE_ELEM_INSIDE_CURR_ELEM_OR_DIRECTLY_AFTER';
        
        const content = t(contentText).split('\\n').map((str,idx) => <div key={idx}>{str ? str : <br/>}</div>);
        setContent(content);
    }

    const topLevelPasteHandler = (selectedNode,ele,i) =>{

        if(selectedNode?.ICON_DISPLAY === "TEMPLATE_BODY_DOTS" && ["XML"].includes(templateHeader?.FILETYPE)){
          const error = t('BOX_YOU_CANNOT_PLACE_OBJ_HERE');
          setShowError(true);
          setError(error);
          setInMiddleProcess((prev) => {
            return { ...prev, status: true, index: i };
          });
        }
    }

    const pasteItems = (i) => {
        const index = i + 1;

        if (index < copiedNodes.length) {
            const element = copiedNodes[index];
            const selectedKey = selectedNode.key.split("-");

            setTimeout(() => {
                // Checking whether top level Node is Selected;
                const topLevelRecord =
                    (currentTab === "body" && selectedKey.length <= 3) ||
                    (currentTab !== "body" && selectedKey.length <= 2);

                if(["TEMPLATE_BODY_DOTS"].includes(selectedNode?.ICON_DISPLAY) || translatedData?.length === 0 ){
                    topLevelPasteHandler(selectedNode,element,index);
                }    
                else if (topLevelRecord) {
                    copyItems(true, element, selectedNode);
                    setInMiddleProcess((prev) => {
                        return { ...prev, status: true, index: index };
                    });
                } else if (FIELD_TYPE[selectedNode?.ICON_DISPLAY] && RECORD_TYPE[element.ICON_DISPLAY] && element?.children?.length) {
                    setInMiddleProcess((prev) => {
                        return { ...prev, status: true, index: index };
                    });
                } else if (FIELD_TYPE[element.ICON_DISPLAY] && RECORD_TYPE[selectedNode.ICON_DISPLAY]) {
                    copyItems(true, element, selectedNode);
                } else if (OTHER_TYPE[element.ICON_DISPLAY] && RECORD_TYPE[selectedNode.ICON_DISPLAY]) {
                    updatePasteModalContent();
                    setInMiddleProcess((prev) => {
                        return { ...prev, status: false, index: index, pasteModal: true };
                    });
                } else if (RECORD_TYPE[element.ICON_DISPLAY] && RECORD_TYPE[selectedNode.ICON_DISPLAY]) {
                    updatePasteModalContent();
                    setInMiddleProcess((prev) => {
                        return { ...prev, status: false, index: index, pasteModal: true };
                    });
                } else if (!RECORD_TYPE[element.ICON_DISPLAY] && RECORD_TYPE[selectedNode.ICON_DISPLAY]) {
                    copyItems(true, element, selectedNode);
                    setInMiddleProcess((prev) => {
                        return { ...prev, status: true, index: index };
                    });
                } else {
                    copyItems(false, element, selectedNode);
                    setInMiddleProcess((prev) => {
                        return { ...prev, status: true, index: index };
                    });
                }
            }, 0); 
        }
    }

    // useEffect(() => {
    //     setTimeout(() => {
    //         if (isCopied?.copy && !isCopied?.paste) {
    //             setInMiddleProcess((prev) => {
    //                 return { ...prev, status: false, index: null, isInside: false };
    //             });
    //             let copiedNodes = getSelectedNodes(selectedKeysArray, translatedData) || [];
    //             copiedNodes = copiedNodes.filter(ele => ele.ICON_DISPLAY !== 'TEMPLATE_BODY_DOTS');
    //             setCopiedNodes((prev) => copiedNodes);
    //             if(!copiedNodes?.length) setIsCopied({...isCopied, copy:false});
    //         } else if (isCopied.paste && (contextMenuType === isCopied?.dispatchFrom) && treeType===isCopied?.treeType ) {
    //             pasteItems(-1);
    //         }
    //     }, 0);
    // }, [isCopied]);

    useEffect(() => {
        // If Pasting Process is in Process then it will Keep Pasting
        if (inMiddleProcess.status) {
            const { isInside, index, pasteModal } = inMiddleProcess;
            setTimeout(() => {
                if (!pasteModal && pasteModalTriggered) {
                    copyItems(isInside, copiedNodes[index], selectedNode);
                    setPasteModalTriggered((prev) => false);
                    setInMiddleProcess((prev) => {
                        return { ...prev };
                    });
                } else {
                    pasteItems(index);
                }
            }, 100);
        }
    }, [inMiddleProcess]);


    useEffect(() => {
        setIsCopied(
            { copy: false, paste: false }
        );
        setInMiddleProcess((prev) => {
            return { ...prev, status: false, index: null, isInside: false };
        });
        setCopiedNodes(() => {
            return [];
        });
    }, [leftTree.tree.body.selectedNode]);


    return (<>
            <Dialog open={inMiddleProcess.pasteModal && isCopied?.treeType === parentScreen && contextMenuType === isCopied?.dispatchFrom} maxWidth="xs" fullWidth>
            <DialogTitle className="dialog-header">
                <div className="title">{t("BOX_CONFIRM")}</div>
            </DialogTitle>
            <DialogContent className="dialog-content" dividers>
                <div ref={contentRef}>{content}</div>
            </DialogContent>
            <DialogActions>
                <Button
                    size='small'
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                        setPasteModalTriggered(true);
                        setInMiddleProcess((prev) => {
                            return {
                                ...prev,
                                status: true,
                                isInside: true,
                                pasteModal: false,
                            };
                        });
                    }}
                >
                    {t("BTN_YES")}
                </Button>
                <Button
                    size='small'
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                        setPasteModalTriggered(true);
                        setInMiddleProcess((prev) => {
                            return {
                                ...prev,
                                status: true,
                                isInside: false,
                                pasteModal: false,
                            };
                        });
                    }}
                >
                    {t("BTN_NO")}
                </Button>
                <Button
                    size='small'
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                        setInMiddleProcess((prev) => {
                            return {
                                status: true,
                                isInside: false,
                                index: prev.index,
                                pasteModal: false,
                            };
                        });
                    }}
                >
                    {t("BTN_CANCEL")}
                </Button>
            </DialogActions>
        </Dialog>
        <ErrorModal errorModal={showError} errorMessage={error} handleErrorModal={setShowError} />
        </>

    )
}

export default CopyAndPasteXML